import type { Action } from '@0xtorch/core'
import { type TransactionDecoded, analyzeTransaction } from '@pkg/evm'
import { createEvmAnalyzeDataSource } from './createEvmAnalyzeDataSource'
import type { AnalyzeEvmTransactionParameters } from './types'

export const analyzeEvmTransaction = async ({
  chain,
  transaction,
  assetFetchClient,
  datasourceApiEndpoint,
  evmTokenApiEndpoint,
  accountAddressList,
  converter,
}: AnalyzeEvmTransactionParameters): Promise<{
  readonly transaction: TransactionDecoded
  readonly actions: readonly Action[]
}> => {
  const datasource = createEvmAnalyzeDataSource({
    assetFetchClient,
    datasourceApiEndpoint,
    evmTokenApiEndpoint,
  })
  return await analyzeTransaction({
    chain,
    transaction,
    datasource,
    relatedAddresses: accountAddressList,
    converter,
  })
}
